import React from 'react';
import { FormControl, FormControlProps } from 'react-bootstrap';

const FractionalInput = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { type, numberValue, onNumberChange, ...inputProps } = props;

  const handleFocus = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    props.onFocus?.(e);
    e.target.select();
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    props.onChange?.(e);
    const min = props.min as number | undefined;
    const max = props.max as number | undefined;
    
    let num = toNumber(e.target.value);
    if (num && min && num < min) {
      num = min;
    } else if (num && max && num > max) {
      num = numberValue ?? null;
    }
    
    if (num !== numberValue) {
      onNumberChange?.(num);
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    props.onKeyDown?.(e);
    if (['Minus', 'Equal', 'KeyE'].includes(e.code)) {
      e.preventDefault();
    }
  }

  const toNumber = (value: string): number | null => {
    let num: number | null = parseFloat(value);
    num = !isNaN(num) ? num : null;
    return num;
  }

  return (
    <FormControl
      {...inputProps}
      ref={ref}
      type={type ?? 'number'}
      value={numberValue ?? ''}
      onFocus={handleFocus}
      onChange={handleChange}
      onKeyDown={handleKeyDown} />
  );
});

type Props = {
  numberValue?: number | null;
  onNumberChange?: (value: number | null) => void;
  size?: 'sm' | 'lg';
} & FormControlProps & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>;

export default FractionalInput;